<script setup>
  const props = defineProps({
    project: {
      type: Object,
      required: true
    }
  });
  const rebuildLinkWithParams = (link) => {
    const pageUrl = new URL(window.location);
    const tempLink = new URL(link, window.location.origin);
    const lastSegment  = tempLink.pathname.split('/').filter(Boolean).pop();
    const newLink = new URL(`${pageUrl.pathname}/${lastSegment}`, window.location.origin);
    pageUrl.searchParams.forEach((value, key) => {
      newLink.searchParams.append(key, value);
    });
    return newLink.toString();
  }

</script>

<template>
  <div class="card-shine">
    <div class="card-scale-inside">
      <a :href="rebuildLinkWithParams(project.slug)" class="news-card-link">
        <div class="scale-card">
          <img :alt="project.name"
               v-if="project.featured_image && project.featured_image.fullUrl"
               :src="project.featured_image.fullUrl"
               class="img" />
        </div>
        <p class="inside-text">{{ project.title }}</p>
      </a>

    </div>
  </div>
</template>

<style scoped>

</style>
